module.exports = __webpack_public_path__ + "static/media/Office_Layout.79997656.jpg";